'use client';
import type { FC } from 'react';
import { Button, P } from '@paypoteam/ui-components';
import Link from 'next/link';

import { shopReferral } from '@/lib/gtm';
import { cn } from '@/lib/utils';

import { LocalImage } from '@/components/atoms/LocalImage';

import type { TilesGridProps } from '../SectionShopSearch.types';

const TilesGrid: FC<TilesGridProps> = ({
    tilesData,
    shopLinkPlacement,
    ctaText,
    isCtaVisible,
    onCtaClick,
    emptyListMessage,
    isShopListEmpty,
    ...props
}) => (
    <div
        className={cn(
            'relative grid grid-cols-2 gap-4 bg-background-secondary py-8 before:absolute before:-left-full before:top-0 before:h-full before:w-full before:bg-background-secondary after:absolute after:-right-full after:top-0 after:h-full after:w-full after:bg-background-secondary sm:grid-cols-3 md:grid-cols-4 md:gap-8 lg:grid-cols-5',
            isShopListEmpty && '!grid-cols-1',
        )}
        {...props}
    >
        {tilesData.map(
            ({ id, partnerName, partnerShopLink, partnerLogo }) =>
                partnerShopLink &&
                partnerLogo && (
                    <Link
                        className="flex h-[5.5rem] w-full items-center justify-center rounded-2xl bg-background p-3"
                        key={id}
                        href={partnerShopLink}
                        onClick={() =>
                            shopReferral(partnerName, shopLinkPlacement)
                        }
                        target="_blank"
                    >
                        <LocalImage
                            src={partnerLogo}
                            alt={`logo ${partnerName}`}
                            width={0}
                            height={0}
                            className="h-auto max-h-[2rem] w-auto max-w-full md:max-h-[2.5rem]"
                        />
                    </Link>
                ),
        )}

        {isShopListEmpty ? <P>{emptyListMessage}</P> : null}

        {isCtaVisible ? (
            <Button
                className="col-span-full mt-4 w-fit justify-self-center md:mt-0"
                onClick={onCtaClick}
                data-test-id={
                    props['data-test-id'] && `${props['data-test-id']}-button`
                }
            >
                {ctaText}
            </Button>
        ) : null}
    </div>
);

export default TilesGrid;
